<template>
  <transition name="slide-down">
    <div class="modal-mask" v-show="$store.state.showDonate">
      <div class="modal-wrapper">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content" v-click-outside="closeModal">
            <button
              class="close"
              aria-label="Close"
              @click.prevent="closeModal"
            >
              <span aria-hidden="true"><i class="fe fe-x"></i></span>
            </button>
            <ais-instant-search
              index-name="organizations"
              :search-client="searchClient"
              :stalled-search-delay="200"
            >
              <ais-configure
                :hits-per-page.camel="12"
                v-bind:query="searchQuery"
                :filters="filters"
              />
              <div class="justify-content-center">
                <!-- <div class="col-12"> -->
                <div class="modal-header full-width">
                  <form id="search" class="full-width">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text pr-0 border-right-0">
                          <i class="fe fe-search" id="searchAddon"></i>
                        </span>
                      </div>
                      <ais-search-box>
                        <template slot-scope="{ isSearchStalled, refine }">
                          <input
                            type="search"
                            v-model="searchQuery"
                            @input="refine($event.currentTarget.value)"
                            v-on:keydown.enter.prevent="
                              refine($event.currentTarget.value)
                            "
                            class="form-control pl-2 border-left-0"
                            placeholder="Type an organization name or category"
                            aria-label="Type an organization name or category"
                            aria-describedby="searchAddon"
                          />
                          <div
                            class="spinner-border text-primary mb-1 spinner"
                            role="status"
                            :hidden="!isSearchStalled"
                          >
                            <span class="sr-only">Loading...</span>
                          </div>
                        </template>
                      </ais-search-box>
                    </div>
                  </form>
                </div>
              </div>
              <div class="modal-body" id="items" ref="items">
                <categories />
                <ais-hits>
                  <div slot-scope="{ items }" class="mt-5">
                    <organization-card
                      :item="item"
                      v-for="item in items"
                      :key="item.id"
                    />
                  </div>
                </ais-hits>

                <div class="container text-center organizations-list">
                  <app-loading-indicator />
                  <ais-pagination
                    v-on:page-change="onPageChange"
                    :class-names="{
                      'ais-Pagination-list': 'pagination',
                      'ais-Pagination-item': 'page-item',
                      'ais-Pagination-link': 'page-link',
                    }"
                  />
                </div>
              </div>
            </ais-instant-search>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { EventBus } from "../event-bus.js";
import algoliasearch from "algoliasearch";
import OrganizationCard from "../components/OrganizationCard";
import Categories from "../components/Categories";
import AppLoadingIndicator from "../components/LoadingIndicator";
export default {
  props: {
    // showModal: { default: false },
  },
  name: "Home",
  components: {
    OrganizationCard,
    AppLoadingIndicator,
    Categories,
  },
  data() {
    return {
      searchQuery: "",
      searchClient: algoliasearch(
        "JB7CZTL70W",
        "96798c6c7b3aa65a447ea8cab0603ae6"
      ),
    };
  },
  mounted() {
    let self = this;
    EventBus.$on("clearSearch", function () {
      self.searchQuery = "";
    });
  },
  computed: {
    filters() {
      return this.$store.state.country + "_code > 0  AND active:true";
    },
  },
  methods: {
    closeModal() {
      this.$store.state.showDonate = false;
      EventBus.$emit("clearSearch");
      this.searchQuery = "";
    },
    onPageChange() {
      document.getElementById("items").scrollTo({
        top: 0,
        behavior: "smooth",
      });
      if (!this.$store.state.showDonate) {
        this.$nextTick(function () {
          window.scrollTo({
            top: document.querySelector(".organizations-list").offsetTop - 60,
            left: 0,
            behavior: "smooth",
          });
        });
      }
    },
  },
};
</script>
<style lang="scss">
#search {
  .input-group-prepend span {
    border-radius: 50px 0 0 50px;
  }
  input,
  .input-group-text {
    border-color: #900909;
  }
  .spinner {
    position: absolute;
    top: 13px;
    right: 17px;
  }
  .ais-SearchBox {
    width: calc(100% - 40px);
    input {
      border-radius: 0 50px 50px 0;
    }
  }
}
.pagination {
  justify-content: center;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: block;
  transition: all 0.3s ease;
}

.modal-wrapper {
  display: block;
  z-index: 9999;
}
.modal-body {
  max-height: calc(100vh - 110px);
  overflow: auto;
  z-index: 10000;
}
.modal-dialog {
  height: calc(100vh - 20px);
}
.modal-content {
  height: 100%;
}
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s;
}
.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-100vh);
}
button.close {
  padding: 0;
  background-color: #fff !important;
  border: 0;
  opacity: 1 !important;
  border-radius: 20px;
  width: 30px;
  height: 30px;
  position: absolute;
  top: -5px;
  right: -5px;
  z-index: 100;
}
</style>